import React from 'react';
import { Table, Text } from '../../../app-components';
import { ROUTES } from '../../../Lib/constants';
import { shorten } from '../../../Lib/helpers';
import { allDetailsListSidebarUri } from '../../../Queries/uciReportQuery';

const tableItems = {
  lg: {
    columns: [
      {
        header: 'Stock#',
        type: 'text',
        field: 'repairOrderNumber',
        width: 200,
      },
      {
        header: 'Name',
        width: 200,
        render: ({ item }) => {
          return (
            <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
              {shorten(item?.customerName)}
            </Text>
          );
        },
      },
      {
        header: 'Email',
        type: 'text',
        width: 200,
        render: ({ item }) => {
          return (
            <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
              {item?.customerEmail ? shorten(item?.customerEmail) : '--'}
            </Text>
          );
        },
      },

      {
        header: 'Year',
        type: 'text',
        field: 'year',
        width: 200,
      },
      {
        header: 'Make',
        type: 'text',
        width: 200,
        render: ({ item }) => {
          return (
            <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
              {shorten(item?.make)}
            </Text>
          );
        },
      },
      {
        header: 'Model',
        type: 'text',
        width: 200,
        render: ({ item }) => {
          return (
            <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
              {shorten(item?.model)}
            </Text>
          );
        },
      },
      {
        header: 'Mileage',
        type: 'text',
        field: 'mileage',
        width: 200,
      },
      {
        header: 'VIN',
        type: 'text',
        width: 200,
        render: ({ item }) => {
          return (
            <Text style={{ fontSize: 16, fontFamily: 'Mulish-Medium' }}>
              {shorten(item?.vin)}
            </Text>
          );
        },
      },
    ],
  },
};

export default Table({
  reloadEvent: ROUTES.uciReportList.name,
  uri: allDetailsListSidebarUri,
  ...tableItems,
  action: ({ item }) => ({
    type: 'link',
    link: {
      view: ROUTES.uciReportView.name,
      params: { item: { ...item }, editable: false },
    },
  }),
});
